/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { PackageVoModel } from '@well/delivery-libs/packages/domain';
import { DateTimeWithTimezoneModel } from '@irian-ro/date-utils';
import { OptionalUiIdentifiableModel } from '@well/domain';
import { ShipmentStatusType } from './shipment-status-type.enum';

export class ShipmentDraftVO extends JSONable {
  uuid = '';
  completeShipmentBaseUuid: string | null = null;
  owner = '';
  externalReference: string | null = null;
  shipmentGroupSolutionUuid: string | null = null;
  series: string | null = null;
  packageVOs: PackageVoModel[] = [];
  deliveryNamedLocation: any | null = null;
  deliveryTimeWindowStart: DateTimeWithTimezoneModel | null = null;
  deliveryTimeWindowEnd: DateTimeWithTimezoneModel | null = null;
  pickupNamedLocation: any | null = null;
  pickupTimeWindowStart: DateTimeWithTimezoneModel | null = null;
  pickupTimeWindowEnd: DateTimeWithTimezoneModel | null = null;
  orderNumber: string | null = null;
  tags: string[] = [];
  temporaryShipmentDraftStatus: ShipmentStatusType | null = null;
}

export type  IdentifiableShipmentDraftVO  = ShipmentDraftVO & OptionalUiIdentifiableModel;

export type NestedShipmentDraftVO = IdentifiableShipmentDraftVO & { parentUuid: string, children: NestedShipmentDraftVO[] };
